var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanknotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "url(#pattern0_110_235)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_110_235",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_110_235",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_110_235",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEA0lEQVR4nO2cS2sUQRCABxVFRcRsuleTiA88iAcvMV2bvXj1D+xFQ6qyQhA16j/waLx48IFeBH+AUQT9BYJGRVfxgYrefOHBtx4iulK7CdFEdHp2e3t6pj4oCGSZqf7o7Zru6d4oEgRBEARBEARByCJr+keXaYOnNOAHDVTPaLzXQCf7SpWl3kQrwDMpEFHvRHBbPWk+vEAZ+pYj0V+5zSIaMis6b0MHnY58wQVCA56YLhj1TIahd9rQca/FUBAEQRAEob3kZE2j7n0NJE8TE+1vDSRfU23tb2ouonVnRMvQoTu1BpKLNQ2wDFkDEQRBEAQhTDbtGFuiDR5SgDf54dz7YxWkJAx+VkDXVQnH2FFLkrtKw73K0D3vjYLUR61QrvYk7skimaxkb9lSWWwtuhvwQAqSr4cUytB+a9HK4KTvxHVgwWO2tWge7H0nrgMLBfTFXrTdTT5GGUVbdjj7G7j+ygSCMnQjPaKTFIFA4OfktIhO9lgT0oQNqOZbdI0nNVHG6SoN98aVbX3x/0w9r/FwkeWePBduK7eZ69G/CmRkS9su1CLFrUPL9QDt1AYnFNADfsLhaPxtcIL/x5/pdF7ZEb398CJezJoW+5+vbGNjz8GoUlnYqfQyIbpQrvZog7dtqv208Fvd/bvWdCLH4EXrbSMbFeBze8kzNYSe8TWc5xmy6OLWoeXK0KPEkmcL9tNCubrCZa5Bi9aA51qWPDuMnHWba6CiizAC7ZPcDDVIZVf5BitaA11uu2hDlxzmG57oohnaoIF+tls0X7MIuD5TonnmpIGOaqBX2uBLbXA87sxRD+AeB5JnxurRODnY5u9NNCc27/MGx+PcSwFdcCba0PlY7bXM359o7gnzP/86zr0U4H1XovkFc8z2WuXvs0e//EtvehHnXsrgW3ei8U2s9lrmn7Khg47EbOR3Z0MH4FTMHKzy9ya6UUw42WYhsSuGBj+5Ex3vfaZt/t5Et4IGeuKwRz92lHN4ohXQRWeiDU64yDlI0bq57uxEtKsXx0GKXj1YXacBfzgYNn6s2kZrXeQcpGhGG7zioDfLWsdciqVh0971DpwqDOLmyBHBim73wVEFeCxySNCi+/jgqMGrrQ8ZOMm/yOAy16BFM6v6R1e2sgFeAT7sK+3uihzjXDRvTeUe05azGwHBbeXN+Y22A31xLjq/W8Lwbhwn1he3+LrWstyzNzU2OcaT7Fp0prftdlue5bG+gV0Bko3ouhOieXdllFG066MVckqWkoT9WR4+kpyCxOshRaIhVA50UhLRe52f3ch9GLyd+DG3uU+Z7nhvBKQ8DN1RA7g6keTfe7YyuI/PrchpWvpzKYJ/RsLgvjyd5REEQRAEQRAEIcoevwDPiEuvyZJ8bQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanknotes);
export default __webpack_public_path__ + "static/media/Banknotes.3d37ea7b145d3beeb255d6450977ad7f.svg";
export { ForwardRef as ReactComponent };